import { fasBolt } from 'shared/@generated/icons/fasBolt';
import { fasBrain } from 'shared/@generated/icons/fasBrain';
import { fasChild } from 'shared/@generated/icons/fasChild';
import { fasDogLeashed } from 'shared/@generated/icons/fasDogLeashed';
import { fasHand } from 'shared/@generated/icons/fasHand';
import { fasLineHeight } from 'shared/@generated/icons/fasLineHeight';
import { fasSeal } from 'shared/@generated/icons/fasSeal';
import { fasShieldDog } from 'shared/@generated/icons/fasShieldDog';
import { fasSoap } from 'shared/@generated/icons/fasSoap';
import { fasVolumeXmark } from 'shared/@generated/icons/fasVolumeXmark';
import { Characteristic } from 'shared/@generated/models';
import { View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Text } from 'shared/components/text';
import { FaIcon, Icon } from 'shared/components/icon';

export const CharacteristicBadge = ({ characteristic }: { characteristic: Characteristic }) => {
  const { t } = useTranslation('components');

  const icons: Record<Characteristic, FaIcon> = {
    [Characteristic.GreatWithKids]: fasChild,
    [Characteristic.HighEnergy]: fasBolt,
    [Characteristic.SuperSmart]: fasBrain,
    [Characteristic.LowGrooming]: fasSoap,
    [Characteristic.Protective]: fasShieldDog,
    [Characteristic.Quiet]: fasVolumeXmark,
    [Characteristic.EasyToTrain]: fasDogLeashed,
    [Characteristic.Stubborn]: fasHand,
    [Characteristic.SizeTiny]: fasLineHeight,
    [Characteristic.SizeSmall]: fasLineHeight,
    [Characteristic.SizeMedium]: fasLineHeight,
    [Characteristic.SizeLarge]: fasLineHeight,
    [Characteristic.SizeGiant]: fasLineHeight,
  };

  if (!Object.keys(icons).includes(characteristic)) {
    return null;
  }

  return (
    <View className={'flex-row items-center'}>
      <View className={'relative z-10'}>
        <Icon icon={fasSeal} className={'z-10 size-11 text-yellow-400'} />
        <Icon
          icon={icons[characteristic]}
          className={
            'text-brand-brown-dark absolute left-1/2 top-1/2 z-10 size-4 -translate-x-1/2 -translate-y-1/2'
          }
        />
      </View>

      <Text
        className={
          'text-brand-brown-dark -ml-6 rounded-r-full bg-yellow-300 py-1.5 pl-8 pr-3 text-sm font-bold'
        }
      >
        {t(`breed_badge.${characteristic}`)}
      </Text>
    </View>
  );
};
